import React from 'react';
import RenewalsPortal from './components/containers/renewals/RenewalsPortal/RenewalsPortal';
import ProductLineItemPageWrapper from './components/containers/renewals/ProductLineItem/ProductLineItemPageWrapper';
import RenewalPageWrapper from './components/containers/renewals/RenewalPageWrapper/RenewalPageWrapper';
import Dashboard from './components/containers/dashboard/Dashboard';
import AuthedRoute from './components/widgets/routes/AuthedRoute/AuthedRoute';
import AuthedRouteWrapper from './components/containers/AuthedRouteWrapper/AuthedRouteWrapper';
import * as UserType from './constants/UserType';
import {
  ADMIN_PANEL_URL,
  BRANCH_OVERRIDES,
  COMPLETED_RENEWALS_PORTAL_URL,
  CUSTOMER_SIGNATURE_URL,
  HOME_URL,
  IMITATE_EMPLOYEE_URL,
  INACTIVE_BRANCHES_URL,
  PRODUCT_DETAILS_URL,
  PRODUCT_LIST_URL,
  RENEWAL_NOT_AVAILABLE_URL,
  RENEWALS_PORTAL_URL,
  REPORTS_PORTAL_URL,
  MANAGED_RESTROOM_SERVICES_URL,
  MRS_CUSTOMERS_URL,
  MRS_ORDER_URL,
  MRS_THANKYOU,
  SELECT_BRANCHES_URL,
  SIGN_IN_URL,
  TERMS_AND_CONDITIONS_URL,
  THANK_YOU_URL,
  UNAUTHED_RENEWAL_VIEW_URL,
  MRS_ORDER_APPROVE_URL
} from './route-names';
import UnauthedRoute from './components/widgets/routes/UnauthedRoute/UnauthedRoute';
import UnauthedRenewalPageWrapper from './components/containers/renewals/UnauthedRenewalPageWrapper/UnauthedRenewalPageWrapper';
import RenewalNotAvailable from './components/presenters/renewals/RenewalNotAvailable/RenewalNotAvailable';
import { Route } from 'react-router-dom';
import ThankYouPage from './components/presenters/renewals/ThankYouPage/ThankYouPage';
import CompletedRenewalsPortal from './components/containers/renewals/CompletedRenewalsPortal/CompletedRenewalsPortal';
import ReportsPortal from './components/containers/reports/ReportsPortal/ReportsPortal';
import Login from './components/containers/Auth/Login/Login';
import ImitateEmployeeContainer from './components/containers/admins/ImitateEmployeeContainer/ImitateEmployeeContainer';
import AdminPanelContainer from './components/containers/admins/AdminPanelContainer/AdminPanelContainer';
import CustomEmployeeContainer from './components/containers/admins/SelectBranchesContainer/SelectBranchesContainer';
import InactiveBranchesContainer from './components/containers/admins/InactiveBranchesContainer/InactiveBranchesContainer';
import TermsAndConditionsWrapper from './components/containers/renewals/TermsAndConditionsWrapper/TermsAndConditionsWrapper';
import CustomerSignaturePageWrapper from './components/containers/renewals/CustomerSignaturePageWrapper/CustomerSignaturePageWrapper';
import BranchOverrideContainer from './components/containers/admins/BranchOverridesContainer/BranchOverridesContainer';
import MRSCustomerSearch from './components/containers/MRS/CustomerSearch';
import MRSHome from './components/containers/MRS/ManagedRestroomServices';
import MRSOrderWorkflow from './components/containers/MRS/OrderWorkflow';
import MRSApproveOrder from './components/containers/MRS/ApproveOrder';
import MRSThankyou from './components/presenters/ManagedRestroomServices/ThankyouPage/ThankyouPage';

const wrapRoute =
  (Component) =>
  ({ ...props }) =>
    (
      <AuthedRouteWrapper>
        <Component {...props} />
      </AuthedRouteWrapper>
    );

export default [
  <UnauthedRoute
    key={SIGN_IN_URL}
    exact
    path={SIGN_IN_URL}
    component={Login}
  />,
  <AuthedRoute
    key={MANAGED_RESTROOM_SERVICES_URL}
    exact
    path={MANAGED_RESTROOM_SERVICES_URL}
    component={wrapRoute(MRSHome)}
    permittedUserTypes={[
      UserType.CSM,
      UserType.COM,
      UserType.GM,
      UserType.CSR,
      UserType.CAM,
      UserType.C3,
      UserType.VPO,
      UserType.RVP,
      UserType.RMT
    ]}
  />,
  <AuthedRoute
    key={MRS_ORDER_APPROVE_URL}
    exact
    path={MRS_ORDER_APPROVE_URL}
    component={wrapRoute(MRSApproveOrder)}
    permittedUserTypes={[UserType.GM,UserType.RVP]}
  />,
  <AuthedRoute
    key={MRS_CUSTOMERS_URL}
    exact
    path={MRS_CUSTOMERS_URL}
    component={wrapRoute(MRSCustomerSearch)}
    permittedUserTypes={[
      UserType.CSM,
      UserType.COM,
      UserType.GM,
      UserType.CSR,
      UserType.CAM,
      UserType.C3,
      UserType.VPO,
      UserType.RVP,
      UserType.RMT
    ]}
  />,
  <AuthedRoute
    key={MRS_ORDER_URL}
    exact
    path={MRS_ORDER_URL}
    component={wrapRoute(MRSOrderWorkflow)}
    permittedUserTypes={[
      UserType.CSM,
      UserType.COM,
      UserType.GM,
      UserType.CSR,
      UserType.CAM,
      UserType.C3,
      UserType.VPO,
      UserType.RVP,
      UserType.RMT
    ]}
  />,
  <AuthedRoute
    key={MRS_THANKYOU}
    exact
    path={MRS_THANKYOU}
    component={wrapRoute(MRSThankyou)}
    permittedUserTypes={[
      UserType.CSM,
      UserType.COM,
      UserType.GM,
      UserType.CSR,
      UserType.CAM,
      UserType.C3,
      UserType.VPO,
      UserType.RVP,
      UserType.RMT
    ]}
  />,
  <Route
    key={UNAUTHED_RENEWAL_VIEW_URL}
    exact
    path={UNAUTHED_RENEWAL_VIEW_URL}
    component={UnauthedRenewalPageWrapper}
  />,
  <Route
    key={RENEWAL_NOT_AVAILABLE_URL}
    exact
    path={RENEWAL_NOT_AVAILABLE_URL}
    component={RenewalNotAvailable}
  />,
  <Route
    key={TERMS_AND_CONDITIONS_URL}
    exact
    path={TERMS_AND_CONDITIONS_URL}
    component={TermsAndConditionsWrapper}
  />,
  <Route
    key={CUSTOMER_SIGNATURE_URL}
    exact
    path={CUSTOMER_SIGNATURE_URL}
    component={CustomerSignaturePageWrapper}
  />,
  <Route
    key={THANK_YOU_URL}
    exact
    path={THANK_YOU_URL}
    component={ThankYouPage}
  />,
  <AuthedRoute
    key={RENEWALS_PORTAL_URL}
    exact
    path={RENEWALS_PORTAL_URL}
    component={wrapRoute(RenewalsPortal)}
    permittedUserTypes={[UserType.CSM, UserType.COM, UserType.GM, UserType.CSR, UserType.RVP, UserType.RMT]}
  />,
  <AuthedRoute
    key={HOME_URL}
    exact
    path={HOME_URL}
    component={wrapRoute(Dashboard)}
    permittedUserTypes={[UserType.CSM, UserType.COM, UserType.GM, UserType.CSR, UserType.RVP, UserType.RMT]}
  />,
  <AuthedRoute
    key={PRODUCT_LIST_URL}
    exact
    path={PRODUCT_LIST_URL}
    component={wrapRoute(RenewalPageWrapper)}
    permittedUserTypes={[UserType.CSM, UserType.COM, UserType.GM, UserType.CSR, UserType.RVP, UserType.RMT]}
  />,
  <AuthedRoute
    key={COMPLETED_RENEWALS_PORTAL_URL}
    exact
    path={COMPLETED_RENEWALS_PORTAL_URL}
    component={wrapRoute(CompletedRenewalsPortal)}
    permittedUserTypes={[
      UserType.CSM,
      UserType.COM,
      UserType.GM,
      UserType.CSR,
      UserType.ADMIN,
      UserType.CAM,
      UserType.C3,
      UserType.VPO,
      UserType.RVP,
      UserType.RMT
    ]}
  />,
  <AuthedRoute
    key={REPORTS_PORTAL_URL}
    exact
    path={REPORTS_PORTAL_URL}
    component={wrapRoute(ReportsPortal)}
    permittedUserTypes={[
      UserType.CSM,
      UserType.COM,
      UserType.GM,
      UserType.CSR,
      UserType.ADMIN,
      UserType.CAM,
      UserType.C3,
      UserType.VPO,
      UserType.RVP,
      UserType.RMT
    ]}
  />,
  <AuthedRoute
    key={PRODUCT_DETAILS_URL}
    exact
    path={PRODUCT_DETAILS_URL}
    component={wrapRoute(ProductLineItemPageWrapper)}
    permittedUserTypes={[UserType.CSM, UserType.COM, UserType.GM, UserType.CSR, UserType.RVP, UserType.RMT]}
  />,
  <AuthedRoute
    key={IMITATE_EMPLOYEE_URL}
    exact
    path={IMITATE_EMPLOYEE_URL}
    component={wrapRoute(ImitateEmployeeContainer)}
    permittedUserTypes={[UserType.ADMIN]}
  />,
  <AuthedRoute
    key={ADMIN_PANEL_URL}
    exact
    path={ADMIN_PANEL_URL}
    component={wrapRoute(AdminPanelContainer)}
    permittedUserTypes={[UserType.ADMIN]}
  />,
  <AuthedRoute
    key={SELECT_BRANCHES_URL}
    exact
    path={SELECT_BRANCHES_URL}
    component={wrapRoute(CustomEmployeeContainer)}
    permittedUserTypes={[UserType.ADMIN]}
  />,
  <AuthedRoute
    key={INACTIVE_BRANCHES_URL}
    exact
    path={INACTIVE_BRANCHES_URL}
    component={wrapRoute(InactiveBranchesContainer)}
    permittedUserTypes={[UserType.ADMIN]}
  />,
  <AuthedRoute
    key={BRANCH_OVERRIDES}
    exact
    path={BRANCH_OVERRIDES}
    component={wrapRoute(BranchOverrideContainer)}
    permittedUserTypes={[UserType.ADMIN]}
  />
];
